export enum ConditionCategory {
  PROBLEM_LIST_ITEM = 'Problem List Item',
}
